import { styled } from '@mui/material/styles';

export const PreviewProxyStyle = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
}));

export const PreviewProxyWrapper = styled('div')(() => ({
  width: '70%',
  height: '65%',
}));
